/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'vk': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M8.614 9.166c.256 6.208 3.026 9.062 5.458 9.683l.625.158V9.166h2.544v5.594l.555-.062c1.248-.137 2.465-.916 3.448-1.972a9.726 9.726 0 002.09-3.56h2.543a10.273 10.273 0 01-1.477 3.218 10.06 10.06 0 01-2.978 2.836l-.757.468.794.403c1.311.664 2.47 1.605 3.4 2.76.792.986 1.401 2.11 1.801 3.315h-2.859a7.432 7.432 0 00-2.144-3.253 7.226 7.226 0 00-3.851-1.746l-.565-.072v5.07c-3.596-.018-6.374-1.278-8.287-3.542-1.859-2.2-2.94-5.4-3.102-9.457h2.762z" _fill="#0077C8" _stroke="#0077C8"/>'
  }
})
